<script setup lang="ts">
import { useResultListTeaserStore } from '@/stores/resultListTeaser';

const teaserStore = useResultListTeaserStore();
</script>

<template>
  <div v-if="teaserStore.html" v-html="teaserStore.html"></div>
</template>
